import { HttpClient } from '@angular/common/http';
import { Injectable, PLATFORM_ID, TransferState, inject, makeStateKey } from '@angular/core';
import { Observable, lastValueFrom, take } from 'rxjs';
import { Customer, CustomerMasterData, Deal, DealPayment } from './model';
import { environment } from './../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BillingServiceService {

  platformId = inject(PLATFORM_ID);
  transferState = inject(TransferState);
  myKey = makeStateKey<Deal>('my-data');
  stripeKey = makeStateKey<string>('stripeKey');

  constructor(private http: HttpClient) {

  }

  getOffer(paymentRef: string): Observable<Deal> {
    return this.http.get<Deal>(
      `${environment.apiUrl}/Billing/GetDealDataForPayment/${paymentRef}`);
  }

  getDealForCancel(paymentRef: string): Observable<Deal> {
    return this.http.get<Deal>(
      `${environment.apiUrl}/Billing/GetDealDataForCancel/${paymentRef}`);
  }

  cancel(data: {
    cancelId: string,
    cancelationReason: string
  }): Observable<Deal> {
    return this.http.post<Deal>(`${environment.apiUrl}/Billing/CancelDeal/`, data);
  }

  getCustomerMasterData(): Observable<CustomerMasterData> {
    return this.http.get<CustomerMasterData>(
      `${environment.apiUrl}/Billing/GetCustomerMasterData`);
  }

  updateCustomerData(paymentRef: string, customer: Customer): Observable<string> {
    return this.http.post<string>(
      `${environment.apiUrl}/Billing/UpdateCustomerData/${paymentRef}`, customer);
  }

  getPaymentIntent(paymentRef: string): Observable<{ clientSecret: string, amount: number }> {
    return this.http.get<{ clientSecret: string, amount: number }>(
      `${environment.apiUrl}/Billing/CreatePaymentIntent/${paymentRef}`);
  }

  paymentCompleted(intent: string): Observable<{ nextPayment: DealPayment }> {
    return this.http.get<{ nextPayment: DealPayment }>(
      `${environment.apiUrl}/Billing/PaymentCompleted/${intent}`);
  }

  getSetupIntent(paymentRef: string): Observable<{ clientSecret: string, amount: number }> {
    return this.http.get<{ clientSecret: string, amount: number }>(
      `${environment.apiUrl}/Billing/CreateSetupIntent/${paymentRef}`);
  }

  setupCompleted(intent: string): Observable<{ ok: boolean }> {
    return this.http.get<{ ok: boolean }>(
      `${environment.apiUrl}/Billing/SetupCompleted/${intent}`);
  }
}
